export const CALCULATOR_PARTNER_REWARDS = {
  business_d: {
    teamBonus: 100,

    smart_c: {
      RC: 1000,
      PV: 1,
      CV: 0,
    },

    standart_c: {
      RC: 1000,
      PV: 1,
      CV: 1,
    },

    business_d: {
      RC: 1200,
      PV: 12,
      CV: 12,
    },

    base_d: {
      RC: 2900,
      PV: 20,
      CV: 20,
    },

    premium_d: {
      RC: 5800,
      PV: 20,
      CV: 20,
    },

    vip_d: {
      RC: 14400,
      PV: 20,
      CV: 20,
    },
  },

  base_d: {
    teamBonus: 125,

    smart_c: {
      RC: 1000,
      PV: 1,
      CV: 0,
    },

    standart_c: {
      RC: 1000,
      PV: 1,
      CV: 1,
    },

    business_d: {
      RC: 1200,
      PV: 12,
      CV: 12,
    },

    base_d: {
      RC: 2900,
      PV: 29,
      CV: 29,
    },

    premium_d: {
      RC: 5800,
      PV: 29,
      CV: 29,
    },

    vip_d: {
      RC: 14400,
      PV: 29,
      CV: 29,
    },
  },

  premium_d: {
    teamBonus: 125,

    smart_c: {
      RC: 1000,
      PV: 1,
      CV: 0,
    },

    standart_c: {
      RC: 1000,
      PV: 1,
      CV: 1,
    },

    business_d: {
      RC: 1200,
      PV: 12,
      CV: 12,
    },

    base_d: {
      RC: 2900,
      PV: 29,
      CV: 29,
    },

    premium_d: {
      RC: 5800,
      PV: 58,
      CV: 58,
    },

    vip_d: {
      RC: 14400,
      PV: 58,
      CV: 58,
    },
  },

  vip_d: {
    teamBonus: 150,

    smart_c: {
      RC: 1000,
      PV: 1,
      CV: 0,
    },

    standart_c: {
      RC: 1000,
      PV: 1,
      CV: 1,
    },

    business_d: {
      RC: 1200,
      PV: 12,
      CV: 12,
    },

    base_d: {
      RC: 2900,
      PV: 29,
      CV: 29,
    },

    premium_d: {
      RC: 5800,
      PV: 58,
      CV: 58,
    },

    vip_d: {
      RC: 14400,
      PV: 144,
      CV: 144,
    },
  },
};
